import gql from 'graphql-tag';

const CREATE_EXTERNAL_ISSUE = gql`
    mutation createExternalIssue($input: ExternalIssueInput) {
        createExternalIssue (input: $input) {
            internalCode
        }
    }
`;

export default CREATE_EXTERNAL_ISSUE;
